import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_walking_male_one_predict_instead_of_two~1
			funnel: {
				id: 'ob-male-walking-one-predict',
				locale: ['en'],
			},
		},
	},
]

export default config
